var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"9.33325","y":"12.6667","width":"1.8856","height":"8.48521","transform":"rotate(135 9.33325 12.6667)","key":0}),React.createElement("rect",{"x":"3.3335","y":"9.33327","width":"1.8856","height":"8.48521","transform":"rotate(-135 3.3335 9.33327)","key":1}),React.createElement("rect",{"x":"4","y":"9","width":"2","height":"10","transform":"rotate(-90 4 9)","key":2})]);
}

ArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
